/* ==========================================================================
   Maison Paw — JavaScript del tema (vanilla, sin dependencias)
   ========================================================================== */
(() => {
  'use strict';

  const T = window.MPTheme || { routes: {}, toastMs: 2200 };
  const R = Object.assign(
    {
      root: '/',
      cart: '/cart',
      cartAdd: '/cart/add',
      cartChange: '/cart/change',
      cartUpdate: '/cart/update',
      search: '/search',
      predictiveSearch: '/search/suggest',
      recommendations: '/recommendations/products'
    },
    T.routes
  );

  /* ---------- Utilidades ---------- */
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const debounce = (fn, ms) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), ms);
    };
  };
  const escapeHTML = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const norm = (s) =>
    String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const withParam = (url, key, value) => {
    const u = new URL(url, location.origin);
    u.searchParams.set(key, value);
    return u.pathname + u.search;
  };

  const currencySymbol = T.currencySymbol || '€';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: T.currency || 'EUR' }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' ' + currencySymbol;
    }
  };
  const priceHTML = (cents) => {
    const c = Math.max(0, Math.round(cents || 0));
    return `${Math.floor(c / 100)},<sup>${String(c % 100).padStart(2, '0')} ${escapeHTML(currencySymbol)}</sup>`;
  };

  const fetchJSON = async (url, opts = {}) => {
    const res = await fetch(url, {
      credentials: 'same-origin',
      ...opts,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', ...(opts.headers || {}) }
    });
    let data = null;
    try {
      data = await res.json();
    } catch (e) {
      /* respuesta sin JSON */
    }
    if (!res.ok) {
      const err = new Error((data && (data.description || data.message)) || 'Error ' + res.status);
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (msg, ms) => {
    const el = $('[data-toast]');
    if (!el) return;
    clearTimeout(toastTimer);
    el.textContent = msg;
    const raised = $$('.mp-sticky-bar, .mp-fab').some((b) => !b.hidden && b.offsetParent !== null);
    el.classList.toggle('is-raised', raised);
    el.hidden = false;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
    toastTimer = setTimeout(() => (el.hidden = true), ms || T.toastMs || 2200);
  };

  /* ---------- Carrito (Cart AJAX API) ---------- */
  const setCartCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      if (String(el.textContent) !== String(count)) {
        el.textContent = count;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
    $$('[data-cart-count-label]').forEach((el) => (el.textContent = count));
  };

  const Cart = {
    get: () => fetchJSON(R.cart + '.js'),
    async refreshCount() {
      try {
        const cart = await Cart.get();
        setCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('mp:cart-updated', { detail: { cart } }));
        return cart;
      } catch (e) {
        return null;
      }
    },
    async add(items) {
      const data = await fetchJSON(R.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items }) });
      await Cart.refreshCount();
      return data;
    },
    change(body) {
      return fetchJSON(R.cartChange + '.js', { method: 'POST', body: JSON.stringify(body) });
    },
    update(body) {
      return fetchJSON(R.cartUpdate + '.js', { method: 'POST', body: JSON.stringify(body) });
    }
  };

  const addedMessage = (title) => `✓ ${title} en tu cesta`;
  const errorMessage = (err) =>
    err && err.status === 422 && err.message ? err.message : 'No hemos podido añadirlo. Inténtalo de nuevo.';

  // Botones "Añadir a la cesta" de las tarjetas (delegado)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const id = Number(btn.dataset.variantId);
    if (!id) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      await Cart.add([{ id, quantity: Number(btn.dataset.quantity) || 1 }]);
      toast(addedMessage(btn.dataset.title || 'Producto'));
    } catch (err) {
      toast(errorMessage(err), 3200);
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  });

  window.MP = { Cart, toast, money, priceHTML };

  /* ---------- Desplegables <details class="mp-drop"> ---------- */
  document.addEventListener('click', (e) => {
    $$('details.mp-drop[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('details.mp-drop[open]').forEach((d) => {
      d.removeAttribute('open');
      const s = $('summary', d);
      if (s) s.focus();
    });
  });

  // Selector de país (formulario de localización)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-country-code]');
    if (!b) return;
    const form = b.closest('form');
    const input = form && $('input[name="country_code"]', form);
    if (!input) return;
    input.value = b.dataset.countryCode;
    form.submit();
  });

  /* ---------- Hojas modales (bottom sheets) ---------- */
  let lastFocus = null;
  const openSheet = (sheet) => {
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.body.classList.add('mp-lock');
    const f = $('input:not([type=hidden]), select, textarea, button', $('.mp-sheet__panel', sheet) || sheet);
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  };
  const closeSheet = (sheet) => {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    if (!$('.mp-sheet:not([hidden])')) document.body.classList.remove('mp-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-sheet]');
    if (opener) {
      e.preventDefault();
      openSheet(document.getElementById(opener.dataset.openSheet));
      return;
    }
    const closer = e.target.closest('[data-close-sheet]');
    if (closer) {
      closeSheet(closer.closest('.mp-sheet'));
      return;
    }
    if (e.target.classList && e.target.classList.contains('mp-sheet')) closeSheet(e.target);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.mp-sheet:not([hidden])').forEach(closeSheet);
  });

  /* ---------- Selector de cantidad ---------- */
  class MPQty extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      if (!this.input || this._ready) return;
      this._ready = true;
      this.addEventListener('click', (e) => {
        const b = e.target.closest('button[data-step]');
        if (!b) return;
        e.preventDefault();
        const min = Number(this.input.min || 0);
        const max = this.input.max ? Number(this.input.max) : Infinity;
        const next = Math.min(max, Math.max(min, (Number(this.input.value) || 0) + Number(b.dataset.step)));
        if (next === Number(this.input.value)) return;
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.input.addEventListener('change', () => this.sync());
      this.sync();
    }
    sync() {
      const v = Number(this.input.value) || 0;
      const min = Number(this.input.min || 0);
      const minus = $('[data-step="-1"]', this);
      if (minus && !this.hasAttribute('data-allow-zero')) minus.disabled = v <= Math.max(min, 1);
    }
  }
  customElements.define('mp-qty', MPQty);

  /* ---------- Carrusel hero ---------- */
  class MPSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.bars = $$('[data-bar]', this);
      this.pauseBtn = $('[data-pause]', this);
      this.ms = Math.max(2000, Number(this.dataset.interval) || 5000);
      this.style.setProperty('--mp-slide-ms', this.ms + 'ms');
      this.index = 0;
      this.remaining = this.ms;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paused = this.dataset.autoplay === 'false' || reduce || this.slides.length < 2;

      this.bars.forEach((b, i) => b.addEventListener('click', () => this.go(i)));
      if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => (this.paused ? this.resume() : this.pause()));

      const frame = $('[data-frame]', this) || this;
      frame.addEventListener('touchstart', (e) => (this.x0 = e.touches[0].clientX), { passive: true });
      frame.addEventListener(
        'touchend',
        (e) => {
          if (this.x0 == null) return;
          const d = e.changedTouches[0].clientX - this.x0;
          this.x0 = null;
          if (Math.abs(d) > 40) this.go(this.index + (d < 0 ? 1 : -1));
        },
        { passive: true }
      );
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.go(this.index + 1);
        if (e.key === 'ArrowLeft') this.go(this.index - 1);
      });
      this._vis = () => {
        if (document.hidden) this.hold();
        else if (!this.paused) this.schedule();
      };
      document.addEventListener('visibilitychange', this._vis);
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i > -1) {
          this.go(i);
          this.pause();
        }
      });
      this.render(true);
      if (this.paused) this.classList.add('is-paused');
      this.updatePauseBtn();
      this.schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this._vis);
    }
    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.remaining = this.ms;
      this.render(true);
      this.schedule();
    }
    render(restartBar) {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((s, i) => {
        const active = i === this.index;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) s.removeAttribute('inert');
        else s.setAttribute('inert', '');
      });
      this.bars.forEach((b, i) => {
        b.classList.toggle('is-done', i < this.index);
        b.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        if (i === this.index) {
          if (restartBar) {
            b.classList.remove('is-running');
            void b.offsetWidth;
          }
          b.classList.add('is-running');
        } else b.classList.remove('is-running');
      });
    }
    hold() {
      clearTimeout(this.timer);
      if (this.startedAt) this.remaining = Math.max(0, this.remaining - (Date.now() - this.startedAt));
      this.startedAt = null;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.slides.length < 2 || document.hidden) return;
      this.startedAt = Date.now();
      this.timer = setTimeout(() => this.go(this.index + 1), this.remaining);
    }
    pause() {
      this.hold();
      this.paused = true;
      this.classList.add('is-paused');
      this.updatePauseBtn();
    }
    resume() {
      this.paused = false;
      this.classList.remove('is-paused');
      this.updatePauseBtn();
      this.schedule();
    }
    updatePauseBtn() {
      if (!this.pauseBtn) return;
      this.pauseBtn.textContent = this.paused ? '▶' : 'II';
      this.pauseBtn.setAttribute('aria-label', this.paused ? 'Reanudar carrusel' : 'Pausar carrusel');
    }
  }
  customElements.define('mp-slideshow', MPSlideshow);

  /* ---------- Menú principal con paneles ---------- */
  class MPHeaderNav extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-nav-toggle]');
        if (!b) return;
        e.preventDefault();
        const open = b.getAttribute('aria-expanded') === 'true';
        this.closeAll();
        if (!open) this.open(b);
      });
      this._outside = (e) => {
        if (!this.contains(e.target)) this.closeAll();
      };
      this._esc = (e) => {
        if (e.key !== 'Escape') return;
        const b = $('[data-nav-toggle][aria-expanded="true"]', this);
        this.closeAll();
        if (b) b.focus();
      };
      document.addEventListener('click', this._outside);
      document.addEventListener('keydown', this._esc);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._outside);
      document.removeEventListener('keydown', this._esc);
    }
    open(b) {
      const panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel) return;
      b.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
    closeAll() {
      $$('[data-nav-toggle]', this).forEach((b) => {
        b.setAttribute('aria-expanded', 'false');
        const p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });
    }
  }
  customElements.define('mp-header-nav', MPHeaderNav);

  /* ---------- Búsqueda predictiva ---------- */
  class MPPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.results = $('[data-results]', this);
      this.clearBtn = $('[data-clear]', this);
      if (!this.input || !this.results) return;
      this.cache = {};
      this.input.setAttribute('autocomplete', 'off');
      this.input.addEventListener('input', () => {
        this.toggleClear();
        this.search();
      });
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length > 1 && this.results.innerHTML.trim()) this.show();
      });
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      if (this.clearBtn)
        this.clearBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.input.value = '';
          this.toggleClear();
          this.hide();
          this.input.focus();
        });
      this._outside = (e) => {
        if (!this.contains(e.target)) this.hide();
      };
      document.addEventListener('click', this._outside);
      this.search = debounce(this.search.bind(this), 220);
      this.toggleClear();
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._outside);
    }
    toggleClear() {
      if (this.clearBtn) this.clearBtn.hidden = !this.input.value;
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) return this.hide();
      if (this.cache[q]) return this.render(this.cache[q]);
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      const url =
        `${R.predictiveSearch}?q=${encodeURIComponent(q)}` +
        '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      try {
        const res = await fetch(url, { signal: this.ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = parseHTML(await res.text());
        const inner = $('#shopify-section-predictive-search', doc);
        const html = inner ? inner.innerHTML : '';
        this.cache[q] = html;
        if (this.input.value.trim() === q) this.render(html);
      } catch (e) {
        if (e.name !== 'AbortError') this.hide();
      }
    }
    render(html) {
      this.results.innerHTML = html;
      this.active = -1;
      this.show();
    }
    show() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }
    hide() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
    onKey(e) {
      const opts = $$('[role="option"]', this.results);
      if (e.key === 'Escape') return this.hide();
      if (!opts.length || this.results.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.active = (this.active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach((o, i) => o.setAttribute('aria-selected', i === this.active ? 'true' : 'false'));
        opts[this.active].scrollIntoView({ block: 'nearest' });
        this.input.setAttribute('aria-activedescendant', opts[this.active].id || '');
      } else if (e.key === 'Enter' && this.active > -1 && opts[this.active]) {
        e.preventDefault();
        opts[this.active].click();
      }
    }
  }
  customElements.define('mp-predictive-search', MPPredictiveSearch);

  /* ---------- Galería de producto ---------- */
  class MPGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      if (!this.track) return;
      this.slides = $$('[data-media-id]', this.track);
      this.thumbs = $$('[data-thumb]', this);
      this.dots = $$('[data-dot]', this);
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.goTo(i)));
      let raf;
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.sync());
        },
        { passive: true }
      );
      this._media = (e) => {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(e.detail.mediaId));
        if (i > -1) this.goTo(i);
      };
      document.addEventListener('mp:variant-media', this._media);
    }
    disconnectedCallback() {
      document.removeEventListener('mp:variant-media', this._media);
    }
    goTo(i) {
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.mark(i);
    }
    sync() {
      const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
      this.mark(i);
    }
    mark(i) {
      if (i === this.current) return;
      this.current = i;
      this.thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
      this.dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      this.slides.forEach((s, j) => {
        if (j !== i) $$('video', s).forEach((v) => v.pause());
      });
    }
  }
  customElements.define('mp-gallery', MPGallery);

  /* ---------- Formulario de producto (variantes, cantidad, añadir, contra reembolso) ---------- */
  class MPProductForm extends HTMLElement {
    connectedCallback() {
      this.form = $('form[action*="/cart/add"]', this);
      if (!this.form) return;
      const json = $('script[data-variants]', this);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.idInput = $('input[name="id"]', this.form);
      this.qtyInput = $('input[name="quantity"]', this);
      this.title = this.dataset.title || '';
      this.variant = this.variants.find((v) => String(v.id) === String(this.idInput.value)) || this.variants[0];
      this.bar = this.dataset.stickyBar ? document.getElementById(this.dataset.stickyBar) : null;

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-input]')) this.onOptionChange();
        if (e.target === this.qtyInput) this.updateTotals();
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.add();
      });
      $$('[data-cod]', this).forEach((b) => b.addEventListener('click', () => this.add(true)));
      if (this.bar) {
        const btn = $('[data-sticky-add]', this.bar);
        if (btn) btn.addEventListener('click', () => this.add());
      }
      this.markAvailability();
      this.updateTotals();
    }
    get qty() {
      return Math.max(1, Number(this.qtyInput && this.qtyInput.value) || 1);
    }
    selectedOptions() {
      return $$('[data-option-position]', this).map((fs) => {
        const c = $('input:checked', fs) || $('select', fs);
        return c ? c.value : null;
      });
    }
    onOptionChange() {
      const sel = this.selectedOptions();
      this.variant = this.variants.find((v) => v.options.every((o, i) => sel[i] == null || o === sel[i])) || null;
      $$('[data-option-position]', this).forEach((fs, i) => {
        const label = $('[data-option-value]', fs);
        if (label) label.textContent = sel[i] || '';
      });
      if (this.variant) {
        this.idInput.value = this.variant.id;
        const u = new URL(location.href);
        u.searchParams.set('variant', this.variant.id);
        history.replaceState(history.state, '', u.toString());
        if (this.variant.featured_media) {
          document.dispatchEvent(new CustomEvent('mp:variant-media', { detail: { mediaId: this.variant.featured_media.id } }));
        }
      }
      this.markAvailability();
      this.updateTotals();
    }
    markAvailability() {
      const sel = this.selectedOptions();
      $$('[data-option-position]', this).forEach((fs, pos) => {
        $$('input[data-option-input]', fs).forEach((input) => {
          const test = sel.slice();
          test[pos] = input.value;
          const ok = this.variants.some((v) => v.available && v.options.every((o, i) => test[i] == null || o === test[i]));
          input.closest('.mp-variants__opt').classList.toggle('is-unavailable', !ok);
        });
      });
      const v = this.variant;
      const available = !!(v && v.available);
      $$('[data-add-button], [data-cod]', this).forEach((b) => (b.disabled = !available));
      const addLabel = !v ? 'No disponible' : available ? this.dataset.addLabel || 'Añadir a la cesta' : 'Agotado';
      $$('[data-add-label]', this).forEach((el) => (el.textContent = addLabel));
      $$('[data-stock]', this).forEach((el) => {
        el.textContent = !v ? 'Combinación no disponible' : available ? el.dataset.inStock || 'En stock' : 'Agotado';
        el.classList.toggle('is-out', !available);
      });
      if (this.bar) {
        const b = $('[data-sticky-add]', this.bar);
        if (b) {
          b.disabled = !available;
          b.textContent = available ? 'Añadir' : 'Agotado';
        }
      }
    }
    updateTotals() {
      const v = this.variant;
      if (v) {
        $$('[data-price]', this).forEach((el) => (el.innerHTML = priceHTML(v.price)));
        $$('[data-compare]', this).forEach((el) => {
          el.hidden = !(v.compare_at_price > v.price);
          el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        });
      }
      const minus = this.qtyInput && $('[data-step="-1"]', this.qtyInput.closest('mp-qty') || this);
      if (minus) minus.disabled = this.qty <= 1;
      if (this.bar && v) {
        const q = this.qty;
        const name = this.variants.length > 1 && v.title && v.title !== 'Default Title' ? `${this.title} · ${v.title}` : this.title;
        const lbl = $('[data-sticky-label]', this.bar);
        const tot = $('[data-sticky-total]', this.bar);
        if (lbl) lbl.textContent = q > 1 ? `${q} × ${name}` : name;
        if (tot) tot.textContent = money(v.price * q);
        const img = $('[data-sticky-img]', this.bar);
        if (img && v.featured_image && v.featured_image.src) img.src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=120';
      }
      $$('[data-cod-total]', this).forEach((el) => v && (el.textContent = money(v.price * this.qty)));
    }
    async add(toCheckout) {
      if (!this.variant || !this.variant.available || this.busy) return;
      this.busy = true;
      const buttons = $$('[data-add-button], [data-cod]', this).concat(this.bar ? $$('[data-sticky-add]', this.bar) : []);
      buttons.forEach((b) => b.classList.add('is-loading'));
      try {
        const items = [{ id: this.variant.id, quantity: this.qty }];
        const props = $$('[name^="properties["]', this.form);
        if (props.length) {
          items[0].properties = {};
          props.forEach((p) => {
            if (p.value) items[0].properties[p.name.slice(11, -1)] = p.value;
          });
        }
        await Cart.add(items);
        if (toCheckout) {
          location.href = '/checkout';
          return;
        }
        toast(addedMessage(this.title));
      } catch (err) {
        toast(errorMessage(err), 3200);
      } finally {
        this.busy = false;
        buttons.forEach((b) => b.classList.remove('is-loading'));
      }
    }
  }
  customElements.define('mp-product-form', MPProductForm);

  /* ---------- Recomendaciones de producto ---------- */
  class MPRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._loaded || !this.dataset.url) return;
      this._loaded = true;
      const load = async () => {
        try {
          const res = await fetch(this.dataset.url);
          const doc = parseHTML(await res.text());
          const fresh = $('mp-recommendations', doc);
          if (fresh && $('.mp-card', fresh)) this.innerHTML = fresh.innerHTML;
          else this.closest('.shopify-section') ? (this.closest('.shopify-section').hidden = true) : (this.hidden = true);
        } catch (e) {
          this.hidden = true;
        }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            if (entries.some((en) => en.isIntersecting)) {
              io.disconnect();
              load();
            }
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        io.observe(this);
      } else load();
    }
  }
  customElements.define('mp-recommendations', MPRecommendations);

  /* ---------- "¿Para quién compras hoy?" + carrusel de productos ---------- */
  class MPPetPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-pet]');
        if (!b) return;
        e.preventDefault();
        const wasOn = b.getAttribute('aria-pressed') === 'true';
        if (wasOn) return;
        $$('[data-pet]', this).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        document.dispatchEvent(new CustomEvent('mp:pet-select', { detail: { url: b.dataset.url || '', title: b.dataset.title || '' } }));
        const target = document.getElementById(this.dataset.scrollTo || '');
        if (target && this.dataset.scroll === 'true') target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
  customElements.define('mp-pet-picker', MPPetPicker);

  class MPProductCarousel extends HTMLElement {
    connectedCallback() {
      this.list = $('[data-carousel-list]', this);
      this.titleEl = $('[data-carousel-title]', this);
      this.countEl = $('[data-carousel-count]', this);
      if (!this.list) return;
      this.initial = {
        cards: $$('[data-carousel-item]', this.list).map((n) => n.outerHTML).join(''),
        title: this.titleEl ? this.titleEl.textContent : '',
        count: this.countEl ? this.countEl.textContent : ''
      };
      this.cache = {};
      this._pick = (e) => this.load(e.detail.url, e.detail.title);
      if (this.dataset.listen === 'true') document.addEventListener('mp:pet-select', this._pick);
    }
    disconnectedCallback() {
      document.removeEventListener('mp:pet-select', this._pick);
    }
    setCards(html, title, count) {
      $$('[data-carousel-item]', this.list).forEach((n) => n.remove());
      this.list.insertAdjacentHTML('beforeend', html);
      if (this.titleEl && title) this.titleEl.textContent = title;
      if (this.countEl) this.countEl.textContent = count;
      this.list.scrollTo({ left: 0, behavior: 'smooth' });
    }
    async load(url, title) {
      if (!url) return this.setCards(this.initial.cards, this.initial.title, this.initial.count);
      this.classList.add('is-loading');
      try {
        if (!this.cache[url]) {
          const res = await fetch(withParam(url, 'section_id', 'collection-feed'));
          const doc = parseHTML(await res.text());
          const feed = $('[data-feed]', doc);
          const n = feed ? Number(feed.dataset.count) || 0 : 0;
          this.cache[url] = {
            cards: feed ? feed.innerHTML : '',
            count: n + (n === 1 ? ' producto' : ' productos')
          };
        }
        const c = this.cache[url];
        this.setCards(c.cards, title || this.initial.title, c.count);
      } catch (e) {
        toast('No hemos podido cargar los productos.');
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }
  customElements.define('mp-product-carousel', MPProductCarousel);

  /* ---------- Colección: "Ver más productos" ---------- */
  class MPLoadMore extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-load-more]');
        if (!btn) return;
        e.preventDefault();
        const grid = document.getElementById(this.dataset.grid);
        if (!grid || !btn.dataset.next) return;
        btn.classList.add('is-loading');
        try {
          const res = await fetch(withParam(btn.dataset.next, 'section_id', this.dataset.section));
          const doc = parseHTML(await res.text());
          const newGrid = doc.getElementById(this.dataset.grid);
          if (newGrid) Array.from(newGrid.children).forEach((c) => grid.appendChild(c));
          const fresh = $('mp-load-more', doc);
          if (fresh) this.innerHTML = fresh.innerHTML;
          else this.remove();
        } catch (err) {
          location.href = btn.dataset.next;
        }
      });
    }
  }
  customElements.define('mp-load-more', MPLoadMore);

  /* ---------- Página de la cesta ---------- */
  class MPCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      if (this._ready) return;
      this._ready = true;
      this.queue = debounce((key, qty, line) => this.change(key, qty, line), 350);
      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-line-qty]');
        if (input) this.queue(input.dataset.key, Number(input.value), input.closest('.mp-line'));
        if (e.target.matches('[data-cart-note]')) this.saveNote(e.target.value);
      });
      this.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-line-remove]');
        if (rm) {
          e.preventDefault();
          this.change(rm.dataset.key, 0, rm.closest('.mp-line'));
        }
        const dr = e.target.closest('[data-discount-remove]');
        if (dr) {
          e.preventDefault();
          this.removeCode(dr.dataset.discountRemove);
        }
      });
      this.addEventListener('submit', (e) => {
        if (!e.target.matches('[data-discount-form]')) return;
        e.preventDefault();
        const input = $('input[name="discount"]', e.target);
        const code = (input.value || '').trim();
        if (code) this.applyCode(code);
      });
    }
    replace(sections) {
      const html = sections && sections[this.sectionId];
      if (!html) return location.reload();
      const doc = parseHTML(html);
      const fresh = $('mp-cart', doc);
      if (fresh) this.innerHTML = fresh.innerHTML;
    }
    async change(key, quantity, line) {
      if (line) line.classList.add('is-loading');
      try {
        const cart = await Cart.change({ id: key, quantity, sections: this.sectionId, sections_url: location.pathname });
        this.replace(cart.sections);
        setCartCount(cart.item_count);
      } catch (err) {
        toast(err.status === 422 && err.message ? err.message : 'No hemos podido actualizar la cesta.', 3200);
        const cart = await Cart.update({ updates: {}, sections: this.sectionId, sections_url: location.pathname }).catch(() => null);
        if (cart) this.replace(cart.sections);
        else location.reload();
      }
    }
    async saveNote(note) {
      try {
        await Cart.update({ note });
      } catch (e) {
        /* nada */
      }
    }
    currentCodes(cart) {
      return (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
    }
    setMsg(text, ok) {
      const el = $('[data-discount-msg]', this);
      if (!el) return;
      el.hidden = !text;
      el.textContent = text;
      el.className = 'mp-msg ' + (ok ? 'mp-msg--ok' : 'mp-msg--err');
    }
    async applyCode(code) {
      const form = $('[data-discount-form]', this);
      const btn = form && $('button', form);
      if (btn) btn.classList.add('is-loading');
      try {
        const before = await Cart.get();
        if (!('discount_codes' in before)) {
          location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(R.cart)}`;
          return;
        }
        const codes = this.currentCodes(before);
        if (codes.some((c) => c.toUpperCase() === code.toUpperCase())) {
          this.setMsg(`✓ El código ${code.toUpperCase()} ya está aplicado`, true);
          return;
        }
        let cart = await Cart.update({ discount: codes.concat(code).join(','), sections: this.sectionId, sections_url: location.pathname });
        const found = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
        const ok = !!(found && found.applicable);
        if (!ok) cart = await Cart.update({ discount: codes.join(','), sections: this.sectionId, sections_url: location.pathname });
        this.replace(cart.sections);
        this.setMsg(ok ? `✓ Código ${code.toUpperCase()} aplicado` : 'Este código no es válido o no se puede aplicar a tu cesta', ok);
      } catch (err) {
        this.setMsg('No hemos podido aplicar el código. Inténtalo de nuevo.', false);
      } finally {
        if (btn) btn.classList.remove('is-loading');
      }
    }
    async removeCode(code) {
      try {
        const before = await Cart.get();
        const codes = this.currentCodes(before).filter((c) => c.toUpperCase() !== String(code).toUpperCase());
        const cart = await Cart.update({ discount: codes.join(','), sections: this.sectionId, sections_url: location.pathname });
        this.replace(cart.sections);
      } catch (e) {
        location.reload();
      }
    }
  }
  customElements.define('mp-cart', MPCart);

  // Al añadir desde "Añade también" en la propia cesta, refrescamos la sección
  document.addEventListener('mp:cart-updated', async () => {
    const cartEl = $('mp-cart');
    if (!cartEl || cartEl._refreshing) return;
    cartEl._refreshing = true;
    try {
      const res = await fetch(`${R.cart}?section_id=${cartEl.dataset.sectionId}`);
      const doc = parseHTML(await res.text());
      const fresh = $('mp-cart', doc);
      if (fresh) cartEl.innerHTML = fresh.innerHTML;
    } finally {
      cartEl._refreshing = false;
    }
  });

  /* ---------- Donación (Solidaridad) ---------- */
  class MPDonation extends HTMLElement {
    connectedCallback() {
      this.addBtn = $('[data-donate]', this);
      this.label = $('[data-donate-amount]', this);
      this.ok = $('[data-donate-ok]', this);
      this.addEventListener('click', async (e) => {
        const a = e.target.closest('[data-amount]');
        if (a) {
          $$('[data-amount]', this).forEach((x) => x.setAttribute('aria-pressed', x === a ? 'true' : 'false'));
          this.addBtn.dataset.variantId = a.dataset.variantId;
          if (this.label) this.label.textContent = a.dataset.label;
          if (this.ok) this.ok.hidden = true;
          return;
        }
        const d = e.target.closest('[data-donate]');
        if (!d || !d.dataset.variantId) return;
        d.classList.add('is-loading');
        try {
          await Cart.add([{ id: Number(d.dataset.variantId), quantity: 1 }]);
          if (this.ok) this.ok.hidden = false;
        } catch (err) {
          toast(errorMessage(err), 3200);
        } finally {
          d.classList.remove('is-loading');
        }
      });
    }
  }
  customElements.define('mp-donation', MPDonation);

  /* ---------- Pestañas (cuenta) ---------- */
  class MPTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role="tab"]', this);
      this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t.dataset.tab, true)));
      this.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft'].includes(e.key) || !e.target.matches('[role="tab"]')) return;
        const i = this.tabs.indexOf(e.target);
        const n = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
        n.focus();
        this.select(n.dataset.tab, true);
      });
      const fromHash = location.hash.replace('#', '');
      const initial = this.tabs.some((t) => t.dataset.tab === fromHash) ? fromHash : this.dataset.default || (this.tabs[0] && this.tabs[0].dataset.tab);
      this.select(initial, false);
    }
    select(name, push) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-active', on);
        t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (push) history.replaceState(null, '', '#' + name);
    }
  }
  customElements.define('mp-tabs', MPTabs);

  /* ---------- Repetir pedido ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-reorder]');
    if (!b) return;
    e.preventDefault();
    let items = [];
    try {
      items = JSON.parse(b.dataset.reorder);
    } catch (err) {
      return;
    }
    items = items.filter((i) => i.id);
    if (!items.length) return toast('Estos productos ya no están disponibles.');
    b.classList.add('is-loading');
    try {
      await Cart.add(items);
    } catch (err) {
      // Si alguno ya no está disponible, añadimos el resto uno a uno
      for (const it of items) {
        try {
          await fetchJSON(R.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: [it] }) });
        } catch (e2) {
          /* producto sin stock */
        }
      }
    }
    location.href = R.cart;
  });

  /* ---------- Mis mascotas ---------- */
  const resizeImage = (file, w, h, quality) =>
    new Promise((resolve, reject) => {
      if (!file || !/^image\//.test(file.type)) return reject(new Error('type'));
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        const c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        const k = Math.max(w / img.width, h / img.height);
        const dw = img.width * k;
        const dh = img.height * k;
        c.getContext('2d').drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', quality));
      };
      img.onerror = () => reject(new Error('load'));
      img.src = url;
    });

  class MPPets extends HTMLElement {
    connectedCallback() {
      this.key = 'mp-mascotas-' + (this.dataset.customer || 'invitado');
      this.list = $('[data-pets-list]', this);
      this.empty = $('[data-pets-empty]', this);
      this.form = $('[data-pets-form]', this);
      this.newPhoto = '';
      this.editing = -1;
      let initial = [];
      try {
        initial = JSON.parse(($('script[data-pets-initial]', this) || {}).textContent || '[]') || [];
      } catch (e) {
        initial = [];
      }
      this.pets = this.load();
      if (this.pets == null) this.pets = Array.isArray(initial) ? initial : [];
      this.form &&
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          const el = this.form.elements;
          const nombre = el.nombre.value.trim();
          if (!nombre) return;
          const tipoEl = this.form.querySelector('input[name="tipo"]:checked');
          this.pets.push({ nombre, tipo: tipoEl ? tipoEl.value : 'gato', foto: this.newPhoto || '' });
          if (this.save()) {
            this.form.reset();
            this.newPhoto = '';
            this.setPhotoLabel();
            toast(`🐾 ${nombre} ya forma parte de la familia`);
          } else this.pets.pop();
          this.render();
        });
      const newPhotoInput = $('[data-pets-new-photo]', this);
      newPhotoInput &&
        newPhotoInput.addEventListener('change', async (e) => {
          try {
            this.newPhoto = await resizeImage(e.target.files[0], 320, 320, 0.82);
          } catch (err) {
            toast('No hemos podido leer esa imagen.');
          }
          this.setPhotoLabel();
        });
      this.list.addEventListener('click', (e) => {
        const b = e.target.closest('[data-act]');
        if (!b) return;
        const i = Number(b.closest('[data-i]').dataset.i);
        if (b.dataset.act === 'edit') {
          this.editing = i;
          this.render();
          const inp = $(`[data-i="${i}"] input[name="n"]`, this.list);
          if (inp) inp.focus();
        }
        if (b.dataset.act === 'remove') {
          if (!confirm(`¿Eliminar a ${this.pets[i].nombre}?`)) return;
          this.pets.splice(i, 1);
          this.save();
          this.render();
        }
        if (b.dataset.act === 'cancel') {
          this.editing = -1;
          this.render();
        }
      });
      this.list.addEventListener('submit', (e) => {
        e.preventDefault();
        const i = Number(e.target.closest('[data-i]').dataset.i);
        const n = e.target.elements.n.value.trim();
        if (n) {
          this.pets[i].nombre = n;
          this.save();
        }
        this.editing = -1;
        this.render();
      });
      this.list.addEventListener('change', async (e) => {
        if (!e.target.matches('input[type="file"]')) return;
        const i = Number(e.target.closest('[data-i]').dataset.i);
        try {
          this.pets[i].foto = await resizeImage(e.target.files[0], 320, 320, 0.82);
          this.save();
          this.render();
        } catch (err) {
          toast('No hemos podido leer esa imagen.');
        }
      });
      this.render();
    }
    load() {
      try {
        const raw = localStorage.getItem(this.key);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }
    save() {
      try {
        localStorage.setItem(this.key, JSON.stringify(this.pets));
        return true;
      } catch (e) {
        toast('No queda espacio para más fotos en este dispositivo.', 3200);
        return false;
      }
    }
    setPhotoLabel() {
      const l = $('[data-pets-photo-label]', this);
      if (l) l.textContent = this.newPhoto ? '✓ Foto elegida' : 'Subir foto (opcional)';
    }
    render() {
      const emojis = { gato: '🐱', perro: '🐶', otro: '🐾' };
      const tipos = { gato: 'Gato', perro: 'Perro', otro: 'Mascota' };
      this.empty && (this.empty.hidden = this.pets.length > 0);
      this.list.innerHTML = this.pets
        .map((m, i) => {
          const emoji = emojis[m.tipo] || '🐾';
          const name = escapeHTML(m.nombre);
          const photo = m.foto && /^data:image\/|^https:\/\//.test(m.foto) ? `<img src="${escapeHTML(m.foto)}" alt="${name}">` : `<span aria-hidden="true">${emoji}</span>`;
          const title =
            this.editing === i
              ? `<form class="mp-pet__rename"><input class="mp-input" name="n" value="${name}" required maxlength="40" aria-label="Nombre de la mascota"><button class="mp-btn mp-btn--ink" type="submit">Guardar</button></form>`
              : `<strong class="mp-pet__name">${name}</strong>`;
          return `<article class="mp-pet" data-i="${i}">
            <label class="mp-pet__photo" title="Cambiar foto">${photo}<span class="mp-pet__cam" aria-hidden="true">📷</span><input type="file" accept="image/*" aria-label="Cambiar foto de ${name}"></label>
            <div class="mp-pet__info">${title}<span class="mp-pet__type">${emoji} ${tipos[m.tipo] || 'Mascota'}</span>
              <div class="mp-pet__actions">${
                this.editing === i
                  ? '<button type="button" class="mp-link-btn mp-link-btn--muted" data-act="cancel">Cancelar</button>'
                  : '<button type="button" class="mp-link-btn" data-act="edit">Cambiar nombre</button><button type="button" class="mp-link-btn mp-link-btn--muted" data-act="remove">Eliminar</button>'
              }</div>
            </div></article>`;
        })
        .join('');
      const line = this.pets.length ? '🐾 Familia de ' + this.pets.map((p) => p.nombre).join(', ') : '';
      $$('[data-pet-line]').forEach((el) => {
        el.textContent = line;
        el.hidden = !line;
      });
    }
  }
  customElements.define('mp-pets', MPPets);

  /* ---------- Muro de adopciones ---------- */
  class MPAdoptionWall extends HTMLElement {
    connectedCallback() {
      this.ads = $$('[data-ad]', this);
      this.filter = 'todos';
      this.city = $('[data-city]', this);
      this.count = $('[data-ad-count]', this);
      this.empty = $('[data-ad-empty]', this);
      this.addEventListener('click', (e) => {
        const f = e.target.closest('[data-filter]');
        if (!f) return;
        this.filter = f.dataset.filter;
        $$('[data-filter]', this).forEach((x) => {
          const on = x === f;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.apply();
      });
      if (this.city) this.city.addEventListener('input', debounce(() => this.apply(), 150));
      this.apply();
    }
    apply() {
      const c = norm(this.city ? this.city.value : '');
      let n = 0;
      this.ads.forEach((a) => {
        const ok = (this.filter === 'todos' || a.dataset.tipo === this.filter) && (!c || norm(a.dataset.city).includes(c));
        a.hidden = !ok;
        if (ok) n++;
      });
      if (this.count) this.count.textContent = n + (n === 1 ? ' animal busca hogar' : ' animales buscan hogar');
      if (this.empty) {
        this.empty.hidden = n > 0;
        const t = $('[data-ad-empty-title]', this.empty);
        if (t) t.textContent = this.ads.length ? 'No hay anuncios con estos filtros' : 'Todavía no hay anuncios';
      }
    }
  }
  customElements.define('mp-adoption-wall', MPAdoptionWall);

  /* ---------- Direcciones: país → provincias ---------- */
  const initCountrySelect = (select) => {
    if (select._mp) return;
    select._mp = true;
    const target = document.getElementById(select.dataset.provinceTarget);
    const wrap = target && target.closest('[data-province-wrap]');
    const defaultCountry = select.dataset.default;
    if (defaultCountry) {
      const opt = Array.from(select.options).find((o) => o.value === defaultCountry);
      if (opt) select.value = defaultCountry;
    }
    const fill = (initial) => {
      if (!target) return;
      const opt = select.options[select.selectedIndex];
      let provinces = [];
      try {
        provinces = JSON.parse((opt && opt.dataset.provinces) || '[]');
      } catch (e) {
        provinces = [];
      }
      target.innerHTML = provinces.map(([v, l]) => `<option value="${escapeHTML(v)}">${escapeHTML(l)}</option>`).join('');
      if (wrap) wrap.hidden = provinces.length === 0;
      if (initial && target.dataset.default) target.value = target.dataset.default;
    };
    select.addEventListener('change', () => fill(false));
    fill(true);
  };
  const initDom = (root = document) => $$('select[data-country-select]', root).forEach(initCountrySelect);
  document.addEventListener('DOMContentLoaded', () => initDom());
  document.addEventListener('shopify:section:load', (e) => initDom(e.target));
  if (document.readyState !== 'loading') initDom();

  // Contador de la cesta al volver con el botón "atrás" (bfcache)
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) Cart.refreshCount();
  });
})();
